export default "__VITE_ASSET__DjR24RLe__"